import React from 'react';
import LoginComponent from '../../../components/login-page';

const Login = (props) => (
  <LoginComponent open {...props}/>
);

export default Login; 
